<template>
   
    <div>

        <div class="card" style="margin-bottom:10px" v-for="item in itens"
        :key="item.id"
        :item="item">
            <div class="card-body text-left">
            <h5 class="card-title" style="margin-bottom:0px"><small>{{item.titulo}}</small></h5>
            <div class="row">
                <div class="col col-12">
                <p class="card-text" style="padding:0;margin:0;margin-bottom:5px"><small>{{item.subtitulo}}</small></p>
                <div class="progress">
                    <div :class="'progress-bar ' + (item.cor ? item.cor : cor)" role="progressbar" v-bind:style="{width:((100 * item.valor) / item.total).toString() + '%'}" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
                </div>
            </div>
            </div>
        </div>

    </div>          
    
</template>

<script>
export default {
  name: "ListCardsProgress",
  components: {},
  props: {
    itens: Array,
    cor: { type: String, default: "bg-success" },    
  },
  methods: {
    
  },
};
</script>

<style>
</style>